<template>
  <a href="https://jaredbookr.io" target="_blank" class="logo-jb">
    <svg class="JBmarkets" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 781.54 663.34">
      <title>pilot</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            d="M781.54,320.92q0,65.28-31.92,116.65a230.53,230.53,0,0,1-85.47,81.05q-53.52,29.7-132.08,29.7-22.65,0-68.86-3.61-7.15-.66-21-1.64h-79.8V64.2H306.67V421.32q0,103.2-20.51,148.33t-57.48,69.41q-37,24.29-94.62,24.28-64.38,0-134.06-33.6V550.83q78.87,47.74,132.28,47.75,27.94,0,50.94-12.33t36.61-41.69q13.62-29.34,13.63-125.27V64.76H106.83V0H306.67V.08h55.74V0h79.8V251.68c.09-.12.19-.23.28-.36v74.47l-.28.38V487.28q43.67,8.54,80.22,8.53,72.65,0,122.41-44.46t49.77-121.9q0-56.13-27.1-84.49T606,216.57q-37.37,0-82.52,29.7A271.84,271.84,0,0,0,500.75,263V197.22a230.26,230.26,0,0,1,29.86-16.58q51.43-23.8,94.28-23.79,60.48,0,108.56,40.68T781.54,320.92Z"
          ></path>
        </g>
      </g>
    </svg>
    <!-- <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 476.62 367.57"
      class="JBmarkets"
    >
      <path
        class="cls-1"
        d="M476.62,240.47c0,70.08-62.39,127.1-139.1,127.1-38.78,0-75.57-14.95-101.57-40.26-25.69,23-60.41,36.08-96.51,36.18h-.56c-53.76,0-103.13-28.77-125.89-73.41l-.08-.18a135.07,135.07,0,0,1-6.2-14.43l-.08-.22A117.45,117.45,0,0,1,0,236.78l45.82-.19a71.69,71.69,0,0,0,4,23.39,86.89,86.89,0,0,0,4,9.37c15.08,29.49,48.59,48.48,85.42,48.32,26.8-.08,52.27-10.31,69.89-28.06C224,274.72,232.05,255.66,232,236v-4.67h45.82v4.56a118,118,0,0,1-13.39,55c17.53,19.31,44.42,30.89,73.13,30.89,51.44,0,93.28-36.46,93.28-81.28S389,159.19,337.52,159.19c-25.46,0-49.27,8.82-67,24.82l-30.68-34c26.18-23.59,60.88-36.6,97.7-36.6C414.23,113.37,476.62,170.39,476.62,240.47Z"
      ></path>
      <path
        class="cls-1"
        d="M230.55,113.53c-.12-37.95-.06-76.14.18-113.53l45.82.24c-.24,37.27-.3,75.34-.18,113.17Z"
      ></path>
    </svg>-->
  </a>
</template>
<script>
export default {
  name: "Logo"
};
</script>
<style>
.JBmarkets {
  fill: rgba(49, 57, 92, 0.7);
  height: 30px;
  margin: auto;
  display: block;
}

.logo-jb {
  display: flex;
  flex: 0.25;
}

.JBmarkets:hover {
  fill: white;
}
</style>


// WEBPACK FOOTER //
// src/components/utils/Logo.vue